import {
  Component,
  Input,
  SimpleChanges,
  ViewChild,
  Output,
  EventEmitter,
} from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Clientes } from '../../interface/data.interface';
import { MatSort, Sort } from '@angular/material/sort';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
// Logo_de_Servicio_de_Impuestos_Internos
// import logoSii from '../../../../../../assets/images/svgs/Logo_de_Servicio_de_Impuestos_Internos.svg'
import { ChartComponent } from 'ng-apexcharts';
import { Router } from '@angular/router';
import { ChartOptions } from '../factoring-monthly-amount/factoring-monthly-amount.component';
import { PageResult } from 'src/app/common/interfaces/paged-result.interface';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AddClientModalComponent } from '../../modals/add-client-modal/add-client-modal.component';

@Component({
  selector: 'app-table-companies',
  templateUrl: './table-companies.component.html',
  styleUrls: ['./table-companies.component.scss'],
})
export class TableCompaniesComponent {
  @ViewChild('chart') chart: ChartComponent = Object.create(null);
  @ViewChild(MatSort, { static: true }) sort: MatSort = Object.create(null);
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator = Object.create(null);
  public gredientChartOptions: Partial<ChartOptions> | any;
  public dataSource!: MatTableDataSource<Clientes>;
  public boardDeals: Array<Clientes>;
  public showText: boolean = false;
  @Input() recieveFilterName: PageResult<Clientes>;
  @Input() proveedorCompany: PageResult<Clientes>;
  @Input() booleanFlag: boolean;
  @Input() booleanText: boolean;
  @Input() pagedProviderSummaries: PageResult<Clientes>;
  @Output() changePagination = new EventEmitter<any>();
  @Output() changeSorting = new EventEmitter<string>;

  displayedColumns: string[] = [
    'Name',
    'ClientRut',
    'SIIPasswordUpdate',
    'StartCurrentActivities',
    'IsSiiConnected',
  ];

  constructor(private router: Router, private dialog: MatDialog) { }

  ngAfterViewInit(): void { }

  ngOnInit() {
    this.setDataSource(this.pagedProviderSummaries);
    this.paginator._intl.itemsPerPageLabel = 'items por pagina';
  }

  ngOnChanges(changes: SimpleChanges) {
    this.setDataSource(this.pagedProviderSummaries);
    if (changes['pagedProviderSummaries']) {
      const newDeptors = changes['pagedProviderSummaries'].currentValue;
      const length = newDeptors.results.length;
      if (length == 0) {
        this.showText = false;
      }
      this.setDataSource(newDeptors);
    }

    if (changes['recieveFilterName']) {
      const newDeptorsFilter = changes['recieveFilterName'].currentValue;
      // console.log(this.textError);
      // console.log(newDeptorsFilter)
      this.setDataSource(newDeptorsFilter);
    }
  }

  private setDataSource(dataSource: PageResult<Clientes>) {
    const {sortColumn, sortDirection} = dataSource;
    this.dataSource = new MatTableDataSource<Clientes>(dataSource?.results);
    this.paginator.length = dataSource?.totalRows;
    if(sortColumn && sortDirection){
      this.sort.active = sortColumn;
      this.sort.direction = sortDirection === 'asc' ? 'asc' : 'desc';
    }
  }

  public dealDialogOpen(args: any): void {
    this.router.navigate(['dashboards/files-clients'], {
      queryParams: { client: +args },
    });
  }

  public changePaginationTable(event: PageEvent) {
    this.changePagination.emit({
      page: event.pageIndex + 1,
      size: event.pageSize,
    });
  }

  public changeSortingTable(sortState: Sort) {
    if(sortState.direction === '') {
      this.changeSorting.emit('');
      return;
    }
    const sortOrder = `${sortState.active}_${sortState.direction}`;
    this.changeSorting.emit(sortOrder);
  }

  AddClient() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.panelClass = 'modalAddClient';
    const dialogRef = this.dialog.open(AddClientModalComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => {
      console.log('El modal fue cerrado');
    });
  }
}
